module.exports = __webpack_public_path__ + "static/media/plus_square.ab79da31.svg";